import React from 'react';

// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const AssessmentImprovementGCG = () => {

    const prinsipHubunganKerja = [
        {
            bold: "Penilaian (Assessment), ",
            normal: "yaitu program untuk mengidentifikasi tingkat penerapan GCG di perusahaan, yang dilakukan setiap dua tahun guna mengukur efektivitas implementasinya."
        },
        {
            bold: "Evaluasi (Review), ",
            normal: "yaitu program yang bertujuan menilai tindak lanjut hasil assessment pada tahun berikutnya, mencakup evaluasi atas temuan penilaian dan pelaksanaan rekomendasi perbaikan. Evaluasi ini pada dasarnya dilakukan secara internal (self-assessment), namun dapat juga dilakukan dengan diskusi atau asistensi dari penilai independen atau melalui instansi pemerintah yang memiliki kompetensi di bidang GCG."
        },
    ];


    return (
        <section className="bg-white pt-10">
            <div className="container mx-auto pt-10">
                {/* Header Section */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#005da2] mb-6 text-center" data-aos="fade-down">Assessment & Improvement GCG</h2>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        Perusahaan secara konsisten melakukan pengukuran atas penerapan GCG melalui:
                    </p>

                    {/* Mapping data prinsip */}
                    <ol className="list-decimal ml-8 space-y-2 text-lg text-gray-700 leading-relaxed" data-aos="fade-down">
                        {prinsipHubunganKerja.map((item, index) => (
                            <li key={index} className="pl-2 text-justify">
                                <span className="font-bold">{item.bold}</span>
                                <span>{item.normal}</span>
                            </li>
                        ))}
                    </ol>

                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        Hasil assessment dan review tersebut kemudian disampaikan kepada Pemegang Saham.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AssessmentImprovementGCG;
